import comprehensiveMapTypes from './types/comprehensiveMap'
import comprehensiveMapService from '@/api/comprehensiveMap'

const state = {}

const actions = {
  // 查询测站雨量累计值
  [comprehensiveMapTypes.GET_ACCUMULATE_RAIN] ({ commit }, { sID = '22', beginTime = '', endTime = '', minRin = '', maxRain = '', patten = '', searchName = '' }) {
    return new Promise((resolve, reject) => {
      comprehensiveMapService.getAccumulateRain({ sID, beginTime, endTime, minRin, maxRain, patten, searchName }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 查询测站雨量累计值
  [comprehensiveMapTypes.GET_LATEST_WATER_LEVEL1] ({ commit }, { sID = '22', sTID = '', stationType = '', waterFactor = '', searchName = '' }) {
    return new Promise((resolve, reject) => {
      comprehensiveMapService.getLatestWaterLevel({ sID, sTID, stationType, waterFactor, searchName }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 查询实时水情中对应stid水库72小时数据
  [comprehensiveMapTypes.GET_RAINWATER_MINUTES_TOTAL] ({ commit }, { sID = '22', sTID = '', stationType = '', beginTime = '', endTime = '', span = '' }) {
    return new Promise((resolve, reject) => {
      comprehensiveMapService.getRainWaterMinutesTotal({ sID, sTID, stationType, beginTime, endTime, span }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 获得图层控制数据
  [comprehensiveMapTypes.GET_LAYERCONTROL_DATA] ({ commit }, { type = '', aDCD = '', searchName = '' }) {
    return new Promise((resolve, reject) => {
      comprehensiveMapService.getLayerControlData({ type, aDCD, searchName }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 获取雨情/水位数据
   */
  [comprehensiveMapTypes.GET_YURUN_DATA] ({ commit }, { sID = '22', sTID, stationType, beginTime, endTime, span }) {
    return new Promise((resolve, reject) => {
      comprehensiveMapService.getYuRunData({ sID, sTID, stationType, beginTime, endTime, span }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 获取水利工程单个站点详情数据
   */
  [comprehensiveMapTypes.GET_ITEM_DATA] ({ commit }, { id, engineeringType }) {
    return new Promise((resolve, reject) => {
      comprehensiveMapService.getItemData({ id, engineeringType }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 获取水系面
   */
  [comprehensiveMapTypes.GET_RIVER_GEOM_LIST] ({ commit }) {
    return new Promise((resolve, reject) => {
      comprehensiveMapService.getRiverGeomList().then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 获取降雨等值面信息
   */
  [comprehensiveMapTypes.GET_RAIN_GRAPH] ({ commit }, { beginTime, endTime, sID = '22', grade }) {
    return new Promise((resolve, reject) => {
      comprehensiveMapService.getRianGraph({ beginTime, endTime, sID, grade }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  }
}

const mutations = {}

export default {
  state,
  actions,
  mutations
}
